import type { I18nConfig, SupportedLanguage } from './config';

export const localePresets: Record<SupportedLanguage, Partial<I18nConfig>> = {
  en: {
    currency: 'USD',
    dateFormat: 'MM/DD/YYYY',
    timeFormat: '12h',
    timezone: 'America/New_York',
    numberFormat: 'en-US',
  },
  es: {
    currency: 'EUR',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    timezone: 'Europe/Madrid',
    numberFormat: 'es-ES',
  },
  'pt-BR': {
    currency: 'BRL',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    timezone: 'America/Sao_Paulo',
    numberFormat: 'pt-BR',
  },
  'pt-PT': {
    currency: 'EUR',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24h',
    timezone: 'Europe/Lisbon',
    numberFormat: 'pt-PT',
  },
};

export function languageToBcp47(language: SupportedLanguage): string {
  return language;
}
